module.exports = __webpack_public_path__ + "img/5-5.8a78e809.svg";